var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(-1298 -70)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(1298 70)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-robot",
    d: "M32.083,36.417a1.583,1.583,0,1,1-3.167,0,6.34,6.34,0,0,0-6.333-6.333h-9.5A6.34,6.34,0,0,0,6.75,36.417a1.583,1.583,0,0,1-3.167,0,9.51,9.51,0,0,1,9.5-9.5h9.5A9.51,9.51,0,0,1,32.083,36.417Zm1.583-24.542v3.167a2.378,2.378,0,0,1-2.375,2.375H30.5a6.34,6.34,0,0,1-6.333,6.333H11.5a6.34,6.34,0,0,1-6.333-6.333H4.375A2.378,2.378,0,0,1,2,15.042V11.875A2.378,2.378,0,0,1,4.375,9.5h.792A6.34,6.34,0,0,1,11.5,3.167h4.75V1.583a1.583,1.583,0,1,1,3.167,0V3.167h4.75A6.34,6.34,0,0,1,30.5,9.5h.792A2.378,2.378,0,0,1,33.667,11.875ZM27.333,9.5a3.17,3.17,0,0,0-3.167-3.167H11.5A3.17,3.17,0,0,0,8.333,9.5v7.917A3.17,3.17,0,0,0,11.5,20.583H24.167a3.17,3.17,0,0,0,3.167-3.167ZM13.875,11.083a2.375,2.375,0,1,0,2.375,2.375A2.376,2.376,0,0,0,13.875,11.083Zm7.917,0a2.375,2.375,0,1,0,2.375,2.375A2.376,2.376,0,0,0,21.792,11.083Z",
    transform: "translate(1315.167 86)",
    fill: "#393939"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRobot);
export default __webpack_public_path__ + "static/media/userRobot.337c95a7dd9ff77f092a9c2f0d07276c.svg";
export { ForwardRef as ReactComponent };